// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"label_wrapper__1mvYc","left":"label_left__1UEU1","center":"label_center__270yY","right":"label_right__2n7D8","hover":"label_hover__189le"};